import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import z from 'zod'
import { PageWrapper } from '@/shared/ui/page-wrapper'
import { LimitationsWidget } from '@/widgets/limitations-widget'

const searchSchema = z.object({
  'pagination.page': z.number().default(1).optional(),
  'pagination.pageSize': z.number().default(10).optional(),
  'filter.schoolIds': z.array(z.string()).optional(),
  'filter.statuses': z.array(z.string()).optional(),
  'filter.receivedFrom': z.string().optional(),
  'filter.receivedTo': z.string().optional(),
  'filter.completedFrom': z.string().optional(),
  'filter.completedTo': z.string().optional(),
  'filter.searchQuery': z.string().optional(),
  'sort.field': z.string().optional(),
  'sort.order': z.string().optional(),
})

export const Route = createFileRoute('/_auth/applications/limitations/')({
  validateSearch: searchSchema,
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useTranslation()
  return (
    <PageWrapper title={t('Заявки по ограничениям питания')}>
      <LimitationsWidget />
    </PageWrapper>
  )
}
